import { render } from "./SetPasswordView.vue?vue&type=template&id=de0e78b0&scoped=true"
import script from "./SetPasswordView.vue?vue&type=script&lang=js"
export * from "./SetPasswordView.vue?vue&type=script&lang=js"

import "./SetPasswordView.vue?vue&type=style&index=0&id=de0e78b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de0e78b0"]])

export default __exports__